// extracted by mini-css-extract-plugin
export var dataCell = "_i1-2";
export var dataRow = "_i1-0";
export var headerRow = "_i1-1";